import(/* webpackMode: "eager", webpackExports: ["ForgotPasswordWrapper"] */ "/app/src/app/(auth)/forgot-password/components/ForgotPasswordWrapper.tsx");
